import {
  Button,
  Container,
  ListItemText,
  AppBar,
  Box,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  Toolbar,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";
import Brightness1Icon from "@mui/icons-material/Brightness1";
import MenuIcon from "@mui/icons-material/Menu";
import { useEffect, useState } from "react";
import {
  wrapperButton,
  wrapperHeader,
  wrapperMenu,
  wrapperWin,
} from "./topBar.style";
import { useLocation } from "react-router-dom";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import Grid from "@mui/material/Grid2";

const drawerWidth = 240;
const navItems = [
  { label: "Home", to: "https://flashift.app/" },
  {
    label: "How it works",
    to: "https://flashift.app/blog/how-to-swap-across-different-blockchains/",
  },
  { label: "FAQs", to: "https://flashift.app/faq/" },
  { label: "Blog", to: "https://flashift.app/blog/" },
  { label: "Online Support", action: "chat" },
  { label: "About Us", to: "https://flashift.app/about-us/" },
];

const TopBar = () => {
  let location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const handleChat = () => {
    const openChat = () => {
      window.tidioChatApi?.open();
    };

    if (window.tidioChatApi) {
      if (typeof window.tidioChatApi.open === "function") {
        openChat();
      } else {
        window.tidioChatApi.on?.("ready", openChat);
      }
    } else {
      document.addEventListener("tidioChat-ready", openChat, { once: true });
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const currentWindow = window ? window : globalThis.window;
      if (currentWindow && currentWindow.scrollY > 85) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    const currentWindow = window ? window : globalThis.window;

    if (currentWindow) {
      currentWindow.addEventListener("scroll", handleScroll);
      return () => {
        currentWindow.removeEventListener("scroll", handleScroll);
      };
    }
  }, []);

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: "center" }}>
      <Typography variant="h6" sx={{ my: 2 }}>
        <Link to="/">
          <img
            src="/assets/images/logo.svg"
            alt="flashift"
            width="135"
            height="66"
          />
        </Link>
      </Typography>
      <Divider />
      <List>
        {navItems.map((item) => (
          <ListItem key={item.label} disablePadding>
            <ListItemButton sx={{ textAlign: "center" }}>
              <Link
                to={item.to ? item.to : "#"}
                onClick={item.action === "chat" ? handleChat : undefined}
              >
                <ListItemText primary={item.label} />
              </Link>
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <Grid
      sx={{
        ...wrapperHeader,
        position: isSticky ? "fixed" : "relative",
        background: isSticky ? "#19264e" : "#1B191966",
      }}
      container
      py={[3]}
    >
      <Container>
        <Box>
          <Link
            to="/"
            style={{
              position: "absolute",
              top: "23px",
              height: "38px",
            }}
          >
            <img
              src="./assets/images/logo.svg"
              alt="flashift"
              width="135"
              height="66"
            />
          </Link>
        </Box>

        <Grid sx={wrapperMenu}>
          <AppBar component="nav">
            <Toolbar>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
                sx={{ mr: 2, display: { md: "none" }, padding: "0" }}
              >
                <MenuIcon />
              </IconButton>
              <Box sx={{ display: { xs: "none", md: "block" } }}>
                {navItems.map((item) => (
                  <Link
                    key={item.label}
                    to={item.to ? item.to : "#"}
                    onClick={item.action === "chat" ? handleChat : undefined}
                  >
                    <Button
                      sx={{
                        color:
                          location.pathname === item.to
                            ? (theme) => theme?.palette?.primary?.main
                            : (theme) => theme?.palette?.primary?.light,
                        "&:hover": {
                          color:
                            location.pathname === item.to
                              ? (theme) => theme?.palette?.primary?.main
                              : (theme) => theme?.palette?.primary?.light,
                        },
                      }}
                    >
                      <Brightness1Icon />
                      {item.label}
                    </Button>
                  </Link>
                ))}
              </Box>
            </Toolbar>
          </AppBar>
          <nav>
            <Drawer
              anchor="left"
              variant="temporary"
              open={mobileOpen}
              onClose={handleDrawerToggle}
              ModalProps={{
                keepMounted: true,
              }}
              sx={{
                display: { xs: "block", md: "none" },
                "& .MuiDrawer-paper": {
                  boxSizing: "border-box",
                  width: drawerWidth,
                },
              }}
            >
              {drawer}
            </Drawer>
          </nav>
        </Grid>
        <Grid sx={wrapperButton}>
          {/* <IconButton className="notif_item">
            <NotificationsNoneIcon />
          </IconButton> */}
          {/* <Button variant="outlined">
            <AccountBalanceWalletIcon />
            Connect Wallet
          </Button> */}
        </Grid>
      </Container>
      {/* <Grid sx={wrapperWin}>
        <span>🔥</span>
        <Typography variant="h5" pt={1} px={3}>
          Outrun the Radar. Win<span>$1,000.</span>
        </Typography>
        <Typography variant="h6" pt={1.5} pr={3}>
          The Flashift Sprint is LIVE! Master instant, No-KYC swaps and claim
          your share of the prize pool.
        </Typography>
        <Button variant="outlined" size="small">
          <Link to="https://zealy.io/cw/flashift/questboard/6d9d35e2-8273-4fcc-8c35-b5de50210fbf/b01c76f1-cbaf-48b6-998f-80b54efee8fb">
            Join
          </Link>
        </Button>
      </Grid> */}
    </Grid>
  );
};

export default TopBar;
